export class FonomaError<TWrapped = {}> extends Error {
    constructor(message?: string, public wrapped?: TWrapped) {
        super(message);
    }
}
